<!-- vertical-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'vertical' && this.menu ">
  <vertical-layout></vertical-layout>
</ng-container>
<!-- / vertical-layout -->

<!-- horizontal-layout -->
<ng-container *ngIf="coreConfig.layout.type === 'horizontal' && this.menu">
  <horizontal-layout></horizontal-layout>
</ng-container>
<!-- / horizontal-layout -->

<benchat *ngIf="shouldShowBenchat()"></benchat>
<!-- / theme customizer -->

<!-- Privacy overlay: masks sensitive content while the app is backgrounded/inactive -->
<div class="app-privacy-overlay" *ngIf="isAppInBackground">
  <img src="assets/images/logo/logo-white.png" alt="MyBenefits" class="app-privacy-overlay__logo" />
</div>
